import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImpression = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 57.73865 57.74173",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Impression" }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.25,28.87087S9.82151,44.34721,28.86932,44.34721,56.48865,28.87087,56.48865,28.87087,47.91713,13.39452,28.86932,13.39452,1.25,28.87087,1.25,28.87087Z",
		style: {
			stroke: "#FFFFFF",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 28.86932,
		cy: 28.87087,
		r: 15.47313,
		style: {
			fill: "none",
			stroke: "#FFFFFF",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})] }), /* @__PURE__ */ _jsx("circle", {
		cx: 28.86968,
		cy: 28.87087,
		r: 8.21044,
		style: {
			fill: "none",
			stroke: "#FFFFFF",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})] })]
});
export default SvgImpression;
